<template>
  <v-card flat class="ch-post__meta grey lighten-5 mb-6">
    <v-card-text class="pa-2 text-center">
      
      <!-- date -->
      <div class="d-flex align-center justify-center my-2">
        <v-icon small color="primary" class="mr-2">mdi-clock-outline</v-icon>
        <span v-html="postedOn"></span>
      </div>
      
      <!-- avatar -->
      <v-avatar v-if="image" size="96" class="ma-4">
        <v-img :src="image"></v-img>
      </v-avatar>
     
      <!-- author -->
      <div class="my-2"><span v-html="author"></span></div>
     
      <!-- socials -->
      <!-- <div class="d-flex align-center justify-center mb-2" v-if="twitter"> -->
      <v-btn
        v-if="twitter"
        small 
        text 
        block
        color="light-blue accent-3" 
        class="text--original" 
        :href="'https://twitter.com/' + twitter"
        target="_blank" 
        rel="noopener"
      ><v-icon small color="light-blue accent-3" class="mr-1">mdi-twitter</v-icon>{{ twitter }}
      </v-btn>
      <!-- </div> -->
     
      <!-- category -->
<!--       <v-btn
        small 
        depressed 
        text 
        block
        color="primary"
        :href="category.link" 
      >
        <v-icon small class="mr-1">mdi-shield-outline</v-icon>
        <span v-html="category.name"></span>
      </v-btn> -->

    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'PostMeta',

    props: ['author', 'category', 'image', 'posted-on', 'twitter'],
  }
</script>